import React from "react";
import { toAbsoluteUrl } from "../../../_metronic";
import "../../../_metronic/_assets/sass/pages/error/error-5.scss";

export function ErrorPage5() {
  return (
    <>
      <div className="kt-grid kt-grid--ver kt-grid--root">
        <div
          className="kt-grid__item kt-grid__item--fluid kt-grid  kt-error-v5"
          // style={{
          //   backgroundImage: `url(${toAbsoluteUrl("/media/error/bg5.jpg")})`
          // }}
        >
          <div className="kt-error_container">
            {/* <span className="kt-error_title">
              <h1 style>Reporting...</h1>
            </span> */}
            <p className="kt-error_subtitle">Reporting Coming Soon..</p>
            <p className="kt-error_description">
              We're working on it 
              <br /><button style={{ fontSize: "12px", marginTop: "25px", letterSpacing: "0.2rem", color: "#3d4852", padding: "10px 22px 10px 22px", fontWeight: 700, borderWidth: "2px", borderRadius: "0.5rem", borderColor: "#dae1e7", backgroundColor: "transparent", cursor: "pointer", fontFamily: "inherit" }} onClick={() => window.location.pathname = '/dashboard'}>Return Home</button>
              {/* <br />
              as soon possible.
              <br />
              You can back or use our Help Center. */}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
